import React from "react";
import { Box } from "@mantine/core";

const HSpace: React.FC = () => {
  return <Box mr="0.5rem" />;
};

export default HSpace;
